import * as React from 'react'
import Layout from 'src/components/layout'
import { graphql } from 'gatsby'
import Hero from 'src/components/sections/hero'
import Announcements from 'src/components/sections/announcements/Announcements'
import { useRef } from 'react'
import ContactSection from 'src/components/sections/ContactSection'
import TeaserWithHighlight from 'src/components/sections/teaser/TeaserWithHighlight'
import { LIFESTYLE_IMAGES, getDeterministicImage } from 'src/helpers/preview'
import { getPageContent } from 'src/helpers/pageContent'

const IndexPage = ({ data, pageContext }: any) => {
  const language = pageContext?.language || 'en'
  const translation = data?.directus?.pages?.[0]?.translations?.[0]
  const cmsJson = getPageContent('/career', language, translation?.content)

  if (!cmsJson || Object.keys(cmsJson).length === 0) {
    return <h1>Missing translation</h1>
  }
  const ourTeamSection = {
    ...cmsJson.ourTeamSection,
    list: cmsJson.ourTeamSection?.list || cmsJson.ourTeamSection?.icons?.map((icon: any, index: number) => ({
      id: `${index}`,
      ...icon,
    })),
  }

  const getInTouchPlaceholder = {
    ...cmsJson.getInTouchSection,
    image: {
      url: getDeterministicImage('Get in touch', LIFESTYLE_IMAGES),
      alt: 'Get in touch'
    }
  }
  const announcementsRef = useRef(null)

  return (
    <Layout title={cmsJson.title} metas={cmsJson.metas}>
      <Hero
        translationContent={cmsJson.firstSection}
      />
      <Announcements
        ref={announcementsRef}
        translationContent={cmsJson.jobOffersSection}
        announcements={data.directus.job_offers.map(({ id, translations }) => ({
          id,
          ...translations[0],
        }))}
      />
      <TeaserWithHighlight translationContent={getInTouchPlaceholder} splitRatio='7/12'/>
      <TeaserWithHighlight
        translationContent={ourTeamSection}
        hideImage
        listLayout="interactive-rows"
      />
      <TeaserWithHighlight
        translationContent={cmsJson.perksAndBenefitsSection}
        hideImage
        listLayout="interactive-rows"
      />
      <ContactSection />
    </Layout>
  )
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    directus {
      pages(filter: { slug: { _eq: "/career" } }) {
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          content
        }
      }
      job_offers(sort: "sort") {
        id
        translations(filter: { languages_code: { code: { _eq: $language } } }) {
          status
          location
          position
          requirements
          mailSubject: mail_subject
        }
      }
    }
  }
`

export default IndexPage
